<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Result Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading class="mb-3">
      <span v-if="analyte_result" class="float-left mr-2">
        Update Results:
        <span v-if="analyte_result.sample">
          {{ analyte_result.sample.pid }}
        </span>
      </span>

      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'edit analyte result'">
      <template #gated-content>
        <ResultManagerFrom :analyte_result="analyte_result" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue"
import VueNotifications from "vue-notifications"
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils';
import ResultManagerFrom from '@/components/lab/resultmanager/ResultManagerForm'
import { LabRepositoryFactory } from '@/repositories/lab/LabRepositoryFactory'
import { notificationOptions } from "@/shared/toast-notification-options"
import { analyteResultNotifications } from "@/shared/notifications"

const AnalyteResultRepository = LabRepositoryFactory.get("analyteResult")

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'ResultManagerEdit',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    ResultManagerFrom
  },
  data () {
    return {
      loading: true,
      analyte_result_id: this.$route.params.analyte_result_id || null,
      analyte_result: null,
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: 'fa-eye',
            linkto: `/result-manager/${this.analyte_result_id}`,
            title: 'View Result',
            variant: "info",
          }
        ]
      }
    }
  },
  methods: {
    async submit (form_data) {
      try {
        await AnalyteResultRepository.update(this.analyte_result.id, form_data)

        this.editSuccess()
        this.$router.push(`/result-manager/${this.analyte_result_id}`)
      } catch ({ response }) {
        console.log(response)
        const { status, data } = response.response

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        })
      }
    }
  },
  async mounted () {
    this.loading = true

    this.analyte_result = await getModel({
      model_type: 'analyte_result',
      id: this.analyte_result_id,
      message: this.$bvModal
    })
    
    this.loading = false
  },
  notifications: analyteResultNotifications
}
</script>
